import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import {
  deleteMall,
  getMallList,
  getMallPublishHistory,
  updatePublishStatus,
} from 'app/api/mall';
import { APP_CONSTANTS, LocalSessionKey } from 'app/constants/app-constants';
import Message from 'app/utils/Message';
import Toast from 'app/utils/Toast';
import { useEffect } from 'react';
import { LocalStorage } from 'app/utils/storage';

const useMallManagement = () => {
  const user = JSON.parse(LocalStorage.get(LocalSessionKey.RELOAD_MALL));
  useEffect(() => {
    if (user) {
      window.location.reload();
      LocalStorage.remove(LocalSessionKey.RELOAD_MALL);
    }
  }, []);

  const [isdeleteFiltering, setIsdeleteFiltering] = useState(false); // New state to track filtering
  const [openModel, setOpenModel] = useState(false);
  const [publishhistory, setPublishhistory] = useState({});
  const navigate = useNavigate();
  const sectionObj = {
    sectionTitle: 'Mall Management',
    searchObj: {
      keys: ['name', 'adddress', 'city', 'contact_number'],
      placeholder: 'Search by Name, City, Contact No.',
      searchType: 'server',
      handleSearch: (e) => {
        console.log('Handle search: ', e);
        // inputChangeHandler(e);
      },
    },
    buttons: [
      {
        customclassName: '',
        imgTrue: true,
        title: APP_CONSTANTS.CREATE_MALL_TAG,
        handleBtnClick: (e) => {
          navigate(`${APP_CONSTANTS.CREATE_MALL}`);
        },
      },
    ],
  };

  const [pageCount, setPageCount] = useState(1);
  const [pageLoading, setPageLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const dataPerPage = 10;
  const [filteredData, setFilteredData] = useState([]);

  const [totalNumber, setTotalNumber] = useState(0);

  const fetchMallData = useCallback(
    async (page, search = '') => {
      setPageLoading(true);
      try {
        const response = await getMallList(page, dataPerPage, search); // Pass searchValue to API call
        if (response?.responseCode === 200) {
          const dataArr = response?.data?.malls || [];
          const newArray = dataArr.map((item) => ({
            ...item,
            timing: item?.opening_time + ' - ' + item?.closing_time,
          }));
          setFilteredData(newArray);

          const totalCount = response?.data?.count || 0;
          setTotalNumber(totalCount);
          const tempcount = Math.ceil(totalCount / dataPerPage);

          setPageCount(tempcount);
          setIsdeleteFiltering(false);
        } else {
          Toast.error(
            response?.response?.message || Message.Error.COMMON_MESSAGE
          );
        }
      } catch (error) {
        Toast.error(Message.Error.COMMON_MESSAGE);
      } finally {
        setPageLoading(false);
      }
    },
    [dataPerPage]
  );

  const calldeleteMall = async (data, value) => {
    setPageLoading(true);
    if (data && data?.id) {
      let responseObj = await deleteMall(data?.id);
      setPageLoading(false);
      setIsdeleteFiltering(true);
      if (responseObj?.responseCode === 200) {
        Toast.success('Mall Deleted Successfully');
      } else {
        Toast.error(
          responseObj?.response?.message
            ? responseObj?.response?.message
            : 'Failed to delete'
        );
      }
    } else {
      Toast.error('Failed to delete');
    }
  };

  const handleDelete = (data) => {
    confirmAlert({
      title: '',
      message: `Are you sure you want to Delete ${data.name}?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            calldeleteMall(data);
          },
        },
        {
          label: 'No',
        },
      ],
      overlayClassName: 'overlay-custom-class-name',
    });
  };

  function handleEdit(data) {
    navigate(`/mall/edit/:${data.id}`, {
      state: {
        ...data,
      },
    });
  }
  const [mallData, setMallData] = useState({});

  const handleStatusChange = async (data) => {
    try {
      let response = await getMallPublishHistory(data.id);
      setMallData(data);

      if (response?.responseCode === 200) {
        setPublishhistory(response?.data);
        setOpenModel(true);
      } else {
        Toast.error(
          response?.response?.message
            ? response?.response?.message
            : Message.Mall.UPDATE_FAILURE
        );
      }
    } catch (error) {
      Toast.error(error);
    }
  };

  async function publishMall() {
    if (!publishhistory.allConditionsMet.value) {
      Toast.error('All conditions are not met');
      return;
    }
    if (!mallData.status) {
      Toast.error('Mall Status is inactive');
      return;
    }
    setOpenModel(false);
    setPageLoading(true);
    const response = await updatePublishStatus(
      mallData?.id,
      mallData.isPublish ? false : true
    );
    setPageLoading(false);
    if (response?.responseCode === 200) {
      setMallData({});
      Toast.success(response?.message);
      fetchMallData(currentPage);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Mall.UPDATE_FAILURE
      );
    }
  }
  // ------------------------------------------------

  return {
    handleDelete,
    fetchMallData,
    pageLoading,
    handleStatusChange,
    openModel,
    setOpenModel,
    currentPage,
    setCurrentPage,
    dataPerPage,
    pageCount,
    navigate,
    handleEdit,
    sectionObj,
    totalNumber,
    filteredData,
    publishhistory,
    publishMall,
    isdeleteFiltering,
  };
};

export default useMallManagement;
